import React from "react";
import { Button } from "react-bootstrap";
import Select from 'react-select';
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./SettingsMultiSelector.scss";

// const getValuePrefixByTitle = (title) => {
//   switch (title) {
//     case 'Tags':
//       return '_tags:';
//     case 'Products':
//       return 'contentProduct: ';
//     case 'Industries':
//       return 'contentIndustry: ';
//     case 'Regions':
//       return 'contentRegion: ';
//     default:
//       return '_tags:';
//   }
// }

const getColorByTitle = (title) => {
  switch (title) {
    case 'Tags':
      return 'goldenmilk';
    case 'Products':
      return 'waterway';
    case 'Industries':
      return 'fadedtangerine';
    case 'Regions':
      return 'fungreen';
    default:
      return '';
  }
}

const SettingsMultiSelector = props => {
  const [selectedValues, setSelectedValues] = React.useState([]);

  React.useEffect(() => {
    setSelectedValues(props.selected);
  }, [props.selected]);

  const clearSelectedValues = () => {
    setSelectedValues([]);

    if (props.onChange) {
      props.onChange(null);
    }
  };

  const onRemoveValue = idx => {
    const newValues = selectedValues.filter((sv, index) => idx !== index);
    setSelectedValues(newValues);

    if (props.onChange) {
      // props.onChange(newValues.map(nv => `${getValuePrefixByTitle(props.title)}"${nv.trim()}"`));
      props.onChange(newValues);
    }
  };

  const onAddValue = newValue => {
    const newValues = [...selectedValues, newValue.value];
    setSelectedValues(newValues);

    if (props.onChange) {
      // props.onChange(newValues.map(nv => `${getValuePrefixByTitle(props.title)}"${nv.trim()}"`));
      props.onChange(newValues);
    }
  }

  const {
    title,
    options
  } = props;

  return (
    <div className="settings-multi-selector flex flex-col">
      <div className="title">{title}</div>
      <div className="flex items-end justify-between">
        <Select
          className="single-selector"
          classNamePrefix="select"
          placeholder={`+ Select ${title}`}
          value={null}
          onChange={onAddValue}
          isSearchable
          name="color"
          options={Object.keys(options).filter(opk => !selectedValues.includes(opk)).map(op => ({ label: op, value: op }))}
        />
        <Button variant="outline-danger" size="sm" onClick={clearSelectedValues}>CLEAR</Button>
      </div>
      <div className="mt-2 flex flex-wrap">
        {
          selectedValues.map((sel, idx) => (
            <div key={`chip_${idx}`} className={`chip-box ${getColorByTitle(title)} flex items-center`}>
              <span className="mr-2">{sel}</span>
              <FontAwesomeIcon className="cursor-pointer" icon={faTimesCircle} onClick={e => onRemoveValue(idx)} />
            </div>
          ))
        }
      </div>
    </div>
  );
}

export default SettingsMultiSelector;
